var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import DotsHorizontalSvg from './dots-horizontal.icon.svg';
export const DotsHorizontalIcon = (iconInstanceProps) => {
    return _jsx(Icon, { ...iconInstanceProps, SvgComponent: DotsHorizontalSvg });
};
_react_refresh_temp_1 = DotsHorizontalIcon;
$RefreshReg$(_react_refresh_temp_1, "DotsHorizontalIcon");
